import React from 'react';
import { Helmet } from 'react-helmet-async';
import { initializeAnalytics } from '@scrippsproduct/networks-ui-library/dist/utils/analytics'

const ENV = process.env.REACT_APP_ENV
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID 

export default function SEO({ 
    title, 
    description = `Grit is home to your favorite bold, brave, legendary heroes, showcasing timeless action-packed storytelling through its iconic Western movies and series.`, 
    name = 'Grit',
    url = 'https://www.grittv.com',
    siteName = 'Grit',
    image = null,
    favicon = 'favicon',
    type = 'website', 
    robots = 'index' 
}) {
    return (
        // `onChangeClientState` callback initializes Google Analytics.
        // This happens after the page's metadata (including the `<title>` tag) is updated, 
        // ensuring that the page title is accurately tracked in GA4.
        <Helmet onChangeClientState={() => initializeAnalytics('GRIT', ENV, GA_ID)}>
            { /* Standard metadata tags */ }
            <title>{title}</title>
            <meta name='description' content={description} />
            {/* Light Mode Favicons */}
            { (favicon !== null) && <link rel="icon" href={`/${favicon}.ico`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="icon" type="image/png" sizes="16x16" href={`/${favicon}-16x16.png`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="icon" sizes="32x32" href={`/${favicon}-32x32.png`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="icon" sizes="192x192" href={`/${favicon}-192x192.png`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="icon" sizes="512x512" href={`/${favicon}-512x512.png`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="apple-touch-icon" href={`/${favicon}.png`} media="(prefers-color-scheme: light)" /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="192x192" media="(prefers-color-scheme: light)" href={`/${favicon}-192x192.png`} /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="512x512" media="(prefers-color-scheme: light)" href={`/${favicon}-512x512.png`} /> }
            {/* Dark Mode Favicons */}
            { (favicon !== null) && <link rel="icon" href={`/${favicon}-white.ico`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="icon" type="image/png" sizes="16x16" href={`/${favicon}-16x16.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="icon" sizes="32x32" href={`/${favicon}-32x32-white.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="icon" sizes="192x192" href={`/${favicon}-192x192-white.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="icon" sizes="512x512" href={`/${favicon}-512x512-white.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="apple-touch-icon" href={`/${favicon}-white.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="192x192" href={`/${favicon}-192x192-white.png`} media="(prefers-color-scheme: dark)" /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="512x512" href={`/${favicon}-512x512-white.png`} media="(prefers-color-scheme: dark)" /> }

            { /* Facebook tags */ }
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content={siteName} />
            { (image !== null) && <meta property="og:image" content={image}/> }

            { /* Twitter tags */ }
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { (image !== null) && <meta name="twitter:image" content={image} /> }

            <meta name="robots" content={robots} />
        </Helmet>
    )
}